export const PHASES = [
  { id: 'enlistment', name: 'ENLISTMENT', min: 0, max: 3, flavour: 'BMT, area cleaning, guard duty, stores.' },
  { id: 'operational', name: 'OPERATIONAL', min: 4, max: 8, flavour: 'The job gets real. The paperwork remains real.' },
  { id: 'contingency', name: 'CONTINGENCY', min: 9, max: 12, flavour: 'A crisis mobilises reservists.' },
  { id: 'national', name: 'NATIONAL', min: 13, max: 15, flavour: 'You stop being a serviceman and start being the system.' },
  { id: 'strategic', name: 'STRATEGIC', min: 16, max: 18, flavour: 'The numbers have become a national-scale problem.' },
];

export function phaseFor(rankIndex) { return PHASES.find((phase) => rankIndex >= phase.min && rankIndex <= phase.max) || PHASES[0]; }
